/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mixin from "../mixin"; // 引入mixin文件

import floorHeadTitle from "../floorHeadTitle/index";
import i18nMixin from '../../../i18n/i18nMixin';
export default {
  name: "floorDoctorList",
  components: {
    floorHeadTitle: floorHeadTitle
  },
  data: function data() {
    //这里存放数据
    return {
      defaultHeaderImg: require("../../../assets/floor/icon_yisheng_nan.png"),
      iconOptions: {
        twwz: require("../../../assets/floor/icon_tuwenwenzhen@2x.png"),
        dhwz: require("../../../assets/floor/icon_dhwz@2x.png"),
        spwz: require("../../../assets/floor/icon_spzx@2x.png"),
        untwwz: require("../../../assets/floor/icon_t_un@2x.png"),
        undhwz: require("../../../assets/floor/icon_dhwz_un@2x.png"),
        unspwz: require("../../../assets/floor/icon_spzx_un@2x.png"),
        wys: require("../../../assets/floor/icon_zsfw@2x.png")
      },
      doctorList: []
    };
  },
  mixins: [mixin, i18nMixin],
  props: {
    isShowMore: {
      type: Boolean,
      "default": true
    },
    viewMore: {
      type: Object,
      required: false
    },
    isLoadMore: {
      //是否无限滚动
      type: Boolean,
      "default": true
    },
    maxNum: {
      //最大显示条数
      type: Number,
      "default": 2
    },
    dataList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    hiddenTitle: {
      type: Boolean,
      "default": false
    },
    showTags: {
      type: Boolean,
      "default": true
    },
    showFnTags: {
      type: Boolean,
      "default": true
    },
    componentType: {
      type: String,
      "default": "default"
    },
    title: {
      type: String,
      "default": ""
    },
    titleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: "#2E3033",
          fontSize: 18,
          fontWeight: 500
        };
      }
    },
    subTitle: {
      type: String,
      "default": ""
    },
    subTitleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: "#8A8F99",
          fontSize: 12,
          fontWeight: 400
        };
      }
    },
    styleType: {
      type: String,
      "default": "list"
    },
    childTitleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: "#45474D",
          fontSize: 14,
          fontWeight: 500
        };
      }
    },
    childSubTitleStyle: {
      type: Object,
      required: false,
      "default": function _default() {
        return {
          color: "#999",
          fontSize: 12,
          fontWeight: 400
        };
      }
    }
  },
  computed: {},
  methods: {
    setTestList: function setTestList() {
      if (this.isPc) {
        var testList = [];

        for (var index = 1; index <= this.maxNum; index++) {
          var testData = {
            employeeId: "33530efa17f84eb7a48fdc7a84761f39",
            tenantId: "4ee8100a8d874ad784538a93250f1a25",
            hospitalId: null,
            employeeName: this.$t('common.test_name'),
            postName: this.$t('common.test_post_name'),
            titleName: this.$t('common.test_post_name'),
            enabledOnline: true,
            advantageDesc: this.$t('common.test_advantageDesc'),
            headerIcon: "https://gdhznhiptest.city.pingan.com:8888/public/M00/00/08/CglsIV4iteKAD1qbAAEHIHFVifU394.png",
            hospitalName: this.$t('common.test_hospital'),
            departmentName: this.$t('common.test_dept'),
            textInquiryPrice: 0.01,
            voiceInquiryPrice: 30,
            videoInquiryPrice: 50000,
            textInquiryAllow: true,
            voiceInquiryAllow: true,
            videoInquiryAllow: true,
            diagnosisTotal: 0,
            replyDayNum: 2,
            replyPercent: "0%",
            textInquiryEnable: true,
            voiceInquiryEnable: true,
            videoInquiryEnable: true,
            isFollow: true,
            emitName: "handleFocus"
          };
          testList.push(testData);
        }

        this.doctorList = testList;
      }
    },
    hadServers: function hadServers(item) {
      return item.textInquiryAllow || item.voiceInquiryAllow || item.videoInquiryAllow; // 任意一个有都表示有咨询服务
    },
    goMore: function goMore(emitName) {
      this.clickItem(this.viewMore, "", emitName);
    }
  },
  mounted: function mounted() {},
  watch: {
    dataList: {
      handler: function handler(value) {
        if (this.isLoadMore) {
          this.doctorList = value;
        } else {
          this.doctorList = value.slice(0, this.maxNum);
        }
      },
      immediate: true,
      deep: true
    },
    maxNum: {
      handler: function handler(value) {
        this.setTestList();
      },
      immediate: true
    }
  }
};